import { Component, OnInit, Input } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { AppService } from "../../../../services/app.service";
import { MasterService } from "../../../../services/master.service";

@Component({
  selector: "app-payment-detail",
  templateUrl: "./payment-detail.component.html",
  styleUrls: ["./payment-detail.component.scss"]
})
export class PaymentDetailComponent implements OnInit {
  @Input() parent: any;

  formGroup: FormGroup;
  formGroupErrors: any;
  translations: any;
  PaidToList: any = [];
  oPaidTo = '';
  constructor(
    private formBuilder: FormBuilder,
    public appService: AppService,
    public masterService: MasterService
  ) {
    this.appService.showLoading();
    this.setPageTranslations();

    this.formGroupErrors = {
      P_TotalAmount: {},
      P_DepositeAmount: {},
      P_OutstandingAmount: {},
      P_PaidTo: {},
      P_ActualPaid: {},
      P_ActualPaidRemark: {}
    };
  }

  ngOnInit() {
  
    this.loadFormGroup();
    this.bindPaidTo();
  }

  setPageTranslations() {
    this.translations = JSON.parse(sessionStorage.getItem("pageData"));
  }

  changeTotal(e){
    this.parent.order.P_OutstandingAmount = Number(this.parent.order.P_TotalAmount - this.parent.order.P_DepositeAmount).toFixed(2);
      
  }

  changeDeposite(e) {
    this.parent.order.P_OutstandingAmount = Number(this.parent.order.P_TotalAmount - this.parent.order.P_DepositeAmount).toFixed(2);
      
  }

  changeOutstanding(e) {
    this.parent.order.P_DepositeAmount = Number(this.parent.order.P_TotalAmount - this.parent.order.P_OutstandingAmount).toFixed(2);
  }

  updateOutstanding(e){
       this.parent.order.F_CODCAmount = Number(((Number(this.parent.order.P_ActualPaid / 100)) *  Number(this.parent.order.F_CODCost)).toFixed(2)).toString();
       this.parent.order.F_CODCAmount = Number(this.parent.order.F_CODCAmount).toFixed(2).toString();
       
       this.parent.order.P_OutstandingAmount = Number(this.parent.order.P_TotalAmount - this.parent.order.P_DepositeAmount - this.getActualPaid()).toFixed(2);
  }

  getActualPaid(){
    return this.parent.order.P_ActualPaid != undefined && this.parent.order.P_ActualPaid != "" ? this.parent.order.P_ActualPaid : 0;
  }

  bindPaidTo(): void {
    this.masterService
      .selectSysData("PaidTo", this.parent.order.P_PaidTo)
      .subscribe(
        res => this.getOrderTypesSuccess(res),
        error => this.apiFaillure(error)
      );
  }

  getOrderTypesSuccess(res): void {
    if (res.Data != null) {
      this.PaidToList = JSON.parse(res.Data);
      for(let i = 0; i< this.PaidToList.length; i++){
        if(this.parent.order.P_PaidTo == this.PaidToList[i].Id)
        {
          this.oPaidTo = this.PaidToList[i].Value;
        }
      }     
      
      this.appService.hideLoading();
    } else {
      this.apiFaillure(res.Message);
    }
  }

  apiFaillure(error): void {
    this.appService.hideLoading();
    this.appService.showDialogue(
      this.translations.hdError,
      this.translations[error]
    );
  }

  loadFormGroup() {
    if (this.parent.order.Status == 152) {
      this.formGroup = this.formBuilder.group({
        P_TotalAmount: [
          [Validators.pattern(/^\d+(\.\d{1,2})?$/), Validators.required
            ,Validators.max(99999.99),Validators.min(0)]
        ],
        P_DepositeAmount: [
          "",
          [Validators.pattern(/^\-?\d+(\.\d{1,2})?$/), Validators.required,Validators.max(99999.99),Validators.min(-99999.99)]
        ],
        P_OutstandingAmount: [
          { value: '', disabled: true },
          [Validators.pattern(/^\-?\d+(\.\d{1,2})?$/), Validators.required,Validators.max(99999.99),Validators.min(-99999.99)]
        ],
        P_PaidTo: ["", Validators.required],
        P_ActualPaid: ["",[Validators.pattern(/^\-?\d+(\.\d{1,2})?$/), Validators.max(99999.99),Validators.min(-99999.99)]],
        P_ActualPaidRemark: []
      });
    } else {
      this.formGroup = this.formBuilder.group({
        P_TotalAmount: [
          [Validators.pattern(/^\d+(\.\d{1,2})?$/), Validators.required   ,Validators.max(99999.99),Validators.min(0)]
        ],
        P_DepositeAmount: [
          "",
          [Validators.pattern(/^\-?\d+(\.\d{1,2})?$/), Validators.required,Validators.max(99999.99),Validators.min(-99999.99)]
        ],
        P_OutstandingAmount: [
          { value: '', disabled: true },
          [Validators.pattern(/^\-?\d+(\.\d{1,2})?$/), Validators.required,Validators.max(99999.99),Validators.min(-99999.99)]
        ],
        P_PaidTo: [],
        P_ActualPaid: ["",[Validators.pattern(/^\-?\d+(\.\d{1,2})?$/), Validators.max(99999.99),Validators.min(-99999.99)]],
        P_ActualPaidRemark: []
      });
    }
    this.formGroup.valueChanges.subscribe(() => {
      this.formGroupErrors = this.appService.onFormValuesChanged(
        this.formGroup,
        this.formGroupErrors
      );
      this.appService.setFormValid(this.formGroup.invalid);
    });
  }
  changeColor(e){
    if(e.value == 0){
      this.parent.order.P_PaidTo = undefined;
    }
    for(let i = 0; i< e.source.options.length; i++){
      if(e.value == e.source.options._results[i].value)
      {
        e.source._elementRef.nativeElement.firstElementChild.firstElementChild.style.color =  e.source.options._results[i]._element.nativeElement.style.color;
      }
    }
  }
}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/order/order-edit-form/payment-detail/payment-detail.component.ts